import { Button, Checkbox, Popover } from 'antd';
import { map } from 'lodash';
import { memo, useState } from 'react';

import { ORDER_STATUS } from '../common/constants';

const DOWNLOADABLE_STATUSES = [
  ORDER_STATUS?.READY_TO_SHIP?.value,
  ORDER_STATUS?.SHIPPED?.value,
  ORDER_STATUS?.CONFIRMED?.value,
  ORDER_STATUS?.DELIVERED?.value,
  ORDER_STATUS?.NOT_DELIVERED?.value,
];

// eslint-disable-next-line no-undef
const getChallanPopupContainer = () => document.body;

const ChallanDownloadButton = ({
  order,
  handleChallanDownload,
  isChallanLoading,
  className = 'table-action-primary-btn',
  size = 'small',
}) => {
  const [open, setOpen] = useState(false);
  const [selectedIds, setSelectedIds] = useState([]);

  const scheduledOrders = order?.scheduledOrders || [];
  const allIds = map(scheduledOrders, 'id');
  const allChecked = allIds.length > 0 && selectedIds.length === allIds.length;
  const isIndeterminate =
    selectedIds.length > 0 && selectedIds.length < allIds.length;
  const isDisabled = !DOWNLOADABLE_STATUSES?.includes(order?.status);
  const listScrollStyle =
    scheduledOrders.length > 6 ? { height: 220, overflowY: 'auto' } : {};

  const handleDirectDownload = (e) => {
    e?.stopPropagation();
    // eslint-disable-next-line no-undef
    const windowReference = window.open();
    handleChallanDownload(order?.id, windowReference);
  };

  const handleDoneDownload = () => {
    // eslint-disable-next-line no-undef
    const windowReference = window.open();
    setOpen(false);
    handleChallanDownload(order?.id, windowReference, selectedIds);
  };

  if (scheduledOrders?.length > 0) {
    return (
      <Popover
        trigger="click"
        placement="bottom"
        getPopupContainer={getChallanPopupContainer}
        open={open}
        onOpenChange={(isPopoverOpen) => {
          setOpen(isPopoverOpen);
          if (isPopoverOpen) {
            setSelectedIds(allIds);
          }
        }}
        content={
          <div style={{ width: 230 }}>
            <div style={{ fontWeight: 600, marginBottom: 10 }}>
              Select orders for challan
            </div>
            <div style={{ marginBottom: 8 }}>
              <Checkbox
                checked={allChecked}
                indeterminate={isIndeterminate}
                style={{ marginInlineStart: 0 }}
                onChange={(e) => setSelectedIds(e.target.checked ? allIds : [])}
              >
                All
              </Checkbox>
            </div>
            <Checkbox.Group
              value={selectedIds}
              onChange={(values) => setSelectedIds(values)}
              style={{
                display: 'flex',
                flexDirection: 'column',
                gap: 8,
                width: '100%',
                ...listScrollStyle,
              }}
            >
              {map(scheduledOrders, (scheduledOrder) => (
                <Checkbox
                  key={scheduledOrder?.id}
                  value={scheduledOrder?.id}
                  style={{ marginInlineStart: 0 }}
                >
                  {scheduledOrder?.orderNumber}
                </Checkbox>
              ))}
            </Checkbox.Group>
            <div style={{ marginTop: 12, textAlign: 'right' }}>
              <Button
                type="primary"
                size="small"
                className={className}
                disabled={!selectedIds?.length}
                loading={isChallanLoading?.[order?.id]}
                onClick={handleDoneDownload}
              >
                Download
              </Button>
            </div>
          </div>
        }
      >
        <Button
          type="primary"
          size={size}
          className={className}
          loading={isChallanLoading?.[order?.id]}
          disabled={isDisabled}
          onClick={(e) => e?.stopPropagation()}
        >
          Download Challan
        </Button>
      </Popover>
    );
  }

  return (
    <Button
      type="primary"
      size={size}
      className={className}
      loading={isChallanLoading?.[order?.id]}
      disabled={isDisabled}
      onClick={handleDirectDownload}
    >
      Download Challan
    </Button>
  );
};

const areEqual = (prev, next) =>
  prev.order === next.order &&
  prev.isChallanLoading?.[prev.order?.id] ===
    next.isChallanLoading?.[next.order?.id] &&
  prev.className === next.className &&
  prev.size === next.size;

export default memo(ChallanDownloadButton, areEqual);
